import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Publications")
const _hoisted_2 = { key: 0 }

import AppCitation from "@/components/AppCitation.vue";
import publications from "./publications.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'PagePublications',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_AppHeading = _resolveComponent("AppHeading")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _component_AppSection = _resolveComponent("AppSection")!
  const _component_AppGallery = _resolveComponent("AppGallery")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppSection, null, {
      default: _withCtx(() => [
        _createVNode(_component_AppHeading, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createElementVNode("p", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(publications), (group, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              _createVNode(_component_AppLink, {
                to: '#' + group.year
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(group.year), 1)
                ]),
                _: 2
              }, 1032, ["to"]),
              (index !== _unref(publications).length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, " · "))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(publications), (group, index) => {
      return (_openBlock(), _createBlock(_component_AppSection, {
        key: index,
        width: "big"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_AppHeading, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(group.year), 1)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_AppGallery, { size: "big" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.list, (publication, item) => {
                return (_openBlock(), _createBlock(AppCitation, {
                  key: item,
                  title: publication.title,
                  authors: publication.authors,
                  details: [publication.journal, publication.issue, publication.link]
                }, null, 8, ["title", "authors", "details"]))
              }), 128))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ], 64))
}
}

})